export default __webpack_public_path__ + "images/76478e1929c1c3041967ddbf719d6d77.png";